module.exports = __webpack_public_path__ + "img/BFDG.468e1e49.png";